var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("i-repeat", {
    staticClass: "share-list",
    attrs: { items: _vm.shareList },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function ({ item }) {
          return [
            _c(
              "a",
              {
                staticClass: "share-list-a",
                style: item.style,
                attrs: { role: "button", href: item.url, target: item.target },
                on: { click: item.method },
              },
              [
                _c("icon", {
                  staticClass: "share-list-icon",
                  style: item.iconStyle,
                  attrs: { image: item.image, "has-lazyload": true },
                }),
                _vm._v(" "),
                _c("span", { staticClass: "share-list-text" }, [
                  _vm._v("\n        " + _vm._s(item.text) + "\n      "),
                ]),
              ],
              1
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }